// Initialize components module
window.angular.module('MyHippoProducer.Components', []);